import { useQuery } from 'react-query';
import {
  getBettieBalances,
  type GetBettieBalancesResponse
} from '../../services/bettieBalancesService';

type UseGetBettieBalancesOptions = {
  enabled?: boolean;
};

export function useGetBettieBalances(options: UseGetBettieBalancesOptions = {}) {
  const { enabled = true } = options;

  return useQuery<GetBettieBalancesResponse>(['bettieBalances'], getBettieBalances, {
    staleTime: 30_000,
    cacheTime: 60_000,
    enabled
  });
}
